import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  class: "text-truncate",
  style: {"max-width":"100px"}
}
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  key: 0,
  style: {"background":"whitesmoke"}
}
const _hoisted_9 = { colspan: "8" }
const _hoisted_10 = { colspan: "8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn_remove_icon = _resolveComponent("v-btn-remove-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "default_card_wm elevation-0 px-4 py-3 mb-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              (!_ctx.componentForAlreadyDeclaredItems)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "d-flex justify-space-between align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_icon, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDataTable = !_ctx.showDataTable)),
                            icon: _ctx.showDataTable ? '$fa-chevron-up' : '$fa-chevron-down'
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1),
                          (_ctx.fromAutoVATComponent)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Calcul au " + _toDisplayString(_ctx.displayableDate), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.vatItemsSelectedType,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vatItemsSelectedType) = $event)),
                            items: _ctx.vatItemsTypes,
                            "item-title": "text",
                            "item-value": "value",
                            label: "Filtrer par type",
                            outlined: "",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.vatItemsSelectedStatus,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vatItemsSelectedStatus) = $event)),
                            items: _ctx.vatItemsStatus,
                            "item-title": "text",
                            "item-value": "value",
                            label: "Filtrer par statut",
                            outlined: "",
                            "hide-details": "auto",
                            density: "compact"
                          }, null, 8, ["modelValue", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "d-flex justify-end"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.filteredVatItems && _ctx.filteredVatItems.length)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                rounded: "",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vatDeclarationAlreadyDone())),
                                disabled: _ctx.disabledVatDeclararionAlreadyDone,
                                size: "small"
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createTextVNode(" Déclaration de TVA déjà réalisée ")
                                ])),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showDataTable)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_data_table, {
                        headers: _ctx.vatItemsHeaders,
                        items: _ctx.filteredVatItems,
                        density: "compact",
                        "fixed-header": true,
                        color: "primary",
                        itemsPerPage: -1,
                        "hide-default-footer": true,
                        class: "table"
                      }, _createSlots({
                        item: _withCtx((props) => [
                          (_openBlock(), _createElementBlock("tr", {
                            key: props.item.docId
                          }, [
                            _createElementVNode("td", null, [
                              (!_ctx.componentForAlreadyDeclaredItems)
                                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                    key: 0,
                                    "model-value": 
                                            _ctx.selectedVatItemIds.includes(String(props.item.docId))
                                        ,
                                    onClick: _withModifiers((e) => _ctx.selectVatItem(props.item.docId, e), ["stop"]),
                                    color: "primary",
                                    "hide-details": ""
                                  }, null, 8, ["model-value", "onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", {
                              onClick: ($event: any) => (props.item.toggleExpand())
                            }, [
                              _createVNode(_component_v_icon, {
                                color: "secondary",
                                class: "pl-1"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.item.isExpanded
                                                ? "$fa-chevron-up"
                                                : "$fa-chevron-down"), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ], 8, _hoisted_2),
                            _createElementVNode("td", _hoisted_3, [
                              (props.item.gotAnomalies)
                                ? _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    class: "mr-2",
                                    color: "red"
                                  }, {
                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                      _createTextVNode(" $oss-warning ")
                                    ])),
                                    _: 1
                                  })), [
                                    [_directive_tooltip, 
                                            'Anomalie : Le montant de TVA saisi ne correspond pas au montant calculé automatiquement à partir du montant HT et du taux de TVA.'
                                        ]
                                  ])
                                : _createCommentVNode("", true),
                              _createElementVNode("span", null, _toDisplayString(props.item.name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_4, [
                              _createVNode(_component_v_chip, {
                                color: 
                                            [
                                                'Collectée',
                                                'Export',
                                                'Non imposable',
                                                'Z de caisse',
                                            ].includes(props.item.vatScheme)
                                                ? 'green'
                                                : 'primary'
                                        ,
                                size: "small",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.item.vatScheme), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _createElementVNode("td", _hoisted_5, _toDisplayString(props.item.documentDate), 1),
                            _createElementVNode("td", _hoisted_6, _toDisplayString(props.item.vatScheme === "Import"
                                            ? _ctx.newCommonFormatCurrency(
                                                  -props.item.grossAmountAls[0].amountSigned,
                                                  undefined,
                                              )
                                            : ["Acquisition intracom", "Autoliquidation"].includes(
                                                    props.item.vatScheme,
                                                )
                                              ? _ctx.newCommonFormatCurrency(
                                                    Math.abs(props.item.totalGrossAmountSigned),
                                                    undefined,
                                                )
                                              : ["Déductible", "Immobilisation"].includes(
                                                      props.item.vatScheme,
                                                  )
                                                ? _ctx.newCommonFormatCurrency(0, undefined)
                                                : _ctx.newCommonFormatCurrency(
                                                      -props.item.totalNetToDeclare,
                                                      undefined,
                                                  )), 1),
                            _createElementVNode("td", _hoisted_7, _toDisplayString([
                                            "Import",
                                            "Acquisition intracom",
                                            "Autoliquidation",
                                        ].includes(props.item.vatScheme)
                                            ? `+/- ${_ctx.newCommonFormatCurrency(
                                                  Math.abs(props.item.totalVatToDeclare),
                                                  undefined,
                                              )}`
                                            : props.item.vatScheme === "Livraison intracom"
                                              ? _ctx.newCommonFormatCurrency(0, undefined)
                                              : ["Déductible", "Immobilisation"].includes(
                                                      props.item.vatScheme,
                                                  )
                                                ? _ctx.newCommonFormatCurrency(
                                                      props.item.totalVatToDeclare,
                                                      undefined,
                                                  )
                                                : _ctx.newCommonFormatCurrency(
                                                      -props.item.totalVatToDeclare,
                                                      undefined,
                                                  )), 1),
                            _createElementVNode("td", null, [
                              (!_ctx.componentForAlreadyDeclaredItems)
                                ? (_openBlock(), _createBlock(_component_v_switch, {
                                    key: 0,
                                    modelValue: props.item.toAdd,
                                    "onUpdate:modelValue": ($event: any) => ((props.item.toAdd) = $event),
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createBlock(_component_v_btn_remove_icon, {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.removeAlreadyDeclaredItem(props.item)),
                                    style: {"transform":"scale(0.75)"}
                                  }, null, 8, ["onClick"]))
                            ])
                          ])),
                          (props.item.isExpanded)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (
                                        ['Export', 'Non imposable'].includes(props.item.vatScheme)
                                    )
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                      _createElementVNode("td", _hoisted_9, [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.item.vatScheme), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, { cols: "3" }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "text-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" HT : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        Math.abs(props.item.totalGrossAmountSigned),
                                                        undefined,
                                                    )), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, { cols: "3" })
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ]))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.item.details, (detail, index) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: `${props.item.docId}${index}`,
                                        style: {"background":"whitesmoke"}
                                      }, [
                                        _createElementVNode("td", _hoisted_10, [
                                          (props.item.vatScheme === 'Collectée')
                                            ? (_openBlock(), _createBlock(_component_v_row, {
                                                key: 0,
                                                "no-gutters": ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "3",
                                                    class: "text-center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(!detail.bankDate
                                                            ? `TTC : ${_ctx.newCommonFormatCurrency(
                                                                  detail.grossAmountSigned,
                                                                  undefined,
                                                              )}`
                                                            : detail.grossAmountSigned > 0
                                                              ? `${_ctx.newCommonFormatCurrency(
                                                                    detail.grossAmountSigned,
                                                                    undefined,
                                                                )} lettrés le ${detail.bankDate}`
                                                              : `Avoir de ${_ctx.newCommonFormatCurrency(
                                                                    -detail.grossAmountSigned,
                                                                    undefined,
                                                                )}`), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_col, { cols: "9" }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.vats, (vat, vatIndex) => {
                                                        return (_openBlock(), _createBlock(_component_v_row, {
                                                          "no-gutters": "",
                                                          key: `${props.item.docId}${index}${vatIndex}`
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              class: "text-center",
                                                              cols: "4"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.getDisplayCollectedVatDetail(vat)), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, {
                                                              class: "text-center",
                                                              cols: "4"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("HT : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    -vat.netAmountSigned,
                                                                    undefined,
                                                                )), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_component_v_col, {
                                                              class: "text-center",
                                                              cols: "4"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("TVA : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    -vat.vatAmountSigned,
                                                                    undefined,
                                                                )), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (
                                                    props.item.vatScheme === 'Z de caisse' &&
                                                    props.item.totalOutputVat
                                                )
                                            ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "3",
                                                        class: "text-center"
                                                      }, {
                                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                          _createTextVNode("Déductible sur commission")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "3",
                                                        class: "text-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" TVA : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    (props.item.totalOutputVat *
                                                                        props.item.grossAmountAls[
                                                                            index
                                                                        ].amountSigned) /
                                                                        props.item
                                                                            .totalGrossAmountSigned,
                                                                ),
                                                                undefined,
                                                            )), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, { cols: "3" }),
                                                      _createVNode(_component_v_col, { cols: "3" })
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          (props.item.vatScheme === 'Z de caisse')
                                            ? (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.vats, (vat, vatIndex) => {
                                                    return (_openBlock(), _createBlock(_component_v_row, {
                                                      "no-gutters": "",
                                                      key: `${props.item.docId}${index}${vatIndex}`
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (vat.netAmountSigned < 0)
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createVNode(_component_v_col, {
                                                                cols: "3",
                                                                class: "text-center"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(vat.rate
                                                                ? "Collectée"
                                                                : "Livraison intracom"), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                class: "text-center",
                                                                cols: "3"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(vat.rate ? `${vat.rate} %` : ""), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                class: "text-center",
                                                                cols: "3"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString((vat.rate ? "HT : " : "Base : ") +
                                                            _ctx.newCommonFormatCurrency(
                                                                Math.abs(vat.netAmountSigned),
                                                                undefined,
                                                            )), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024),
                                                              _createVNode(_component_v_col, {
                                                                class: "text-center",
                                                                cols: "3"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("TVA : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    Math.abs(vat.vatAmountSigned),
                                                                    undefined,
                                                                )), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ], 64))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : (
                                                    ['Déductible', 'Immobilisation'].includes(
                                                        props.item.vatScheme,
                                                    )
                                                )
                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                  key: 3,
                                                  "no-gutters": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    (detail.bankDate)
                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                          key: 0,
                                                          cols: "3",
                                                          class: "text-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(`${_ctx.newCommonFormatCurrency(
                                                            Math.abs(detail.grossAmountSigned),
                                                            undefined,
                                                        )} payés le ${detail.bankDate} `), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : (_openBlock(), _createBlock(_component_v_col, {
                                                          key: 1,
                                                          cols: "3"
                                                        })),
                                                    _createVNode(_component_v_col, { cols: "3" }),
                                                    _createVNode(_component_v_col, { cols: "3" }),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.vats, (vat, vatIndex) => {
                                                      return (_openBlock(), _createBlock(_component_v_col, {
                                                        cols: "3",
                                                        class: "text-center",
                                                        key: `${props.item.docId}${index}${vatIndex}`
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" TVA : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            vat.vatAmountSigned,
                                                            undefined,
                                                        )), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : (
                                                    [
                                                        'Import',
                                                        'Acquisition intracom',
                                                        'Livraison intracom',
                                                        'Autoliquidation',
                                                    ].includes(props.item.vatScheme)
                                                )
                                                ? (_openBlock(), _createBlock(_component_v_row, {
                                                    key: 4,
                                                    "no-gutters": ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "3",
                                                        class: "text-center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(props.item.vatScheme), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, { cols: "3" }),
                                                      _createVNode(_component_v_col, {
                                                        class: "text-center",
                                                        cols: "3"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("Base : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                props.item.grossAmountAls[index]
                                                                    .amountSigned,
                                                            ),
                                                            undefined,
                                                        )), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_col, {
                                                        class: "text-center",
                                                        cols: "3"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" TVA : " + _toDisplayString(props.item.vatScheme ===
                                                        "Livraison intracom"
                                                            ? _ctx.newCommonFormatCurrency(0, undefined)
                                                            : _ctx.newCommonFormatCurrency(
                                                                  detail.vats[0].vatAmountSigned,
                                                                  undefined,
                                                              )), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    }), 128))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, [
                        (_ctx.filteredVatItems.length && !_ctx.componentForAlreadyDeclaredItems)
                          ? {
                              name: "header.checkbox",
                              fn: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  ripple: false,
                                  "hide-details": "",
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.selectAllVatItems()), ["stop"])),
                                  color: "primary",
                                  "model-value": _ctx.selectedVatItemIds.length === _ctx.filteredVatItems.length
                                }, null, 8, ["model-value"])
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["headers", "items"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}